import { Button, Flex, Image } from "antd";
import React, { useState } from "react";
import { useAuth } from "../../store/context/AuthContext";
import CustomInput from "../../components/input/CustomInput";
import PasswordInput from "../../components/input/PasswordInput";
import { isValidEmail } from "../../utilities/validate";
import { IconLock, IconPhone } from "@tabler/icons-react";
import { Navigate } from "react-router-dom";
import logo from "../../assets/images/logo-black.svg";
import api from "../../api";
import { useToast } from "../../components/toast/toast";

const Login = () => {
  const [email, setEmail] = useState(""); // admin@gmail.com
  const [password, setPassword] = useState(""); // admin123
  const [isLoading, setIsLoading] = useState(false);
  const { isAuthenticated, setAuth } = useAuth();
  const toast = useToast();

  // Login
  const login = async (email, password) => {
    setIsLoading(true);
    const res = await api.login({ email, password });
    // console.log("login res --->", res);
    if (res.status === 200) {
      setAuth(res.data.data.access_token);
      toast("Амжилттай нэвтэрлээ", "success");
    } else {
      // console.error("Login error:", res);
      toast(res.data.message || "Нэвтрэхэд алдаа гарлаа", "error");
    }
    setIsLoading(false);
  };

  if (isAuthenticated) return <Navigate to="/" />;

  return (
    <Flex align="center" justify="center" style={{ height: "100vh" }}>
      <Flex
        vertical
        align="center"
        gap={10}
        style={{
          width: "100%",
          maxWidth: "300px",
          padding: "50px 35px",
          backgroundColor: "#f0f0f0",
          borderRadius: 8,
          border: "1px solid #d9d9d9",
        }}
      >
        <Image
          src={logo}
          preview={false}
          alt="logo"
          style={{ margin: "0 0 30px", width: "100%" }}
        />
        <CustomInput
          placeholder="Имэйл"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoFocus={true}
          prefix={<IconPhone size={16} color="#999" />}
        />
        <PasswordInput
          placeholder="Нууц үг"
          value={password}
          onChange={setPassword}
          prefix={<IconLock size={16} color="#999" />}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              if (email && isValidEmail(email) && password) {
                login(email, password);
              }
            }
          }}
        />

        <Button
          type="primary"
          htmlType="button"
          style={{ width: "100%", height: "40px", margin: "10px 0 0" }}
          onClick={() => login(email, password)}
          disabled={!email || !isValidEmail(email) || !password || isLoading}
          loading={isLoading}
        >
          Нэвтрэх
        </Button>
      </Flex>
    </Flex>
  );
};

export default Login;
